export default __webpack_public_path__ + "static/6880-e1036641afc1dd64bae8305c876086b1.jpg";